@if(branchView()){
  <div class="font-semibold text-xs">{{ getText()['branch'] }}</div>
} @else if (appointment()) {
  <div class="font-semibold text-xs">{{ getText()['yourAppointment'] }}</div>
}@else {
  <div class="font-semibold text-xs">{{ getText()['service'] | format: {actualStep, totalStep} }}</div>
}
